import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";

export default function SeatGauge({ total = 76, restantes = 76, dark = false }) {
  const { t } = useLang();
  const g = t.price;
  const prises = Math.max(0, total - restantes);
  const pct = total > 0 ? Math.round((prises / total) * 100) : 0;
  const textColor = dark ? "text-[#F6F1E8]" : "text-[#14283A]";
  const trackColor = dark ? "bg-[#F6F1E8]/15" : "bg-[#14283A]/10";

  return (
    <div className="w-full" data-testid="seat-gauge">
      <div className={`mb-2 flex items-end justify-between ${textColor}`}>
        <span className="font-marker text-lg text-[#EA7A4F]">{g.gaugeLabel}</span>
        <span className="font-display text-2xl sm:text-3xl" data-testid="seat-gauge-count">
          {restantes}
          <span className="text-base opacity-60"> / {total} {g.seats}</span>
        </span>
      </div>
      <div className={`h-4 w-full overflow-hidden rounded-full ${trackColor}`}>
        <motion.div
          className="grad-bar h-full rounded-full"
          initial={{ width: 0 }}
          whileInView={{ width: `${pct}%` }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
          data-testid="seat-gauge-fill"
        />
      </div>
      <p className={`mt-2 text-sm ${textColor} opacity-70`}>
        {prises === 0 ? g.justOpened : g.raised.replace("{n}", prises)}
      </p>
    </div>
  );
}
